import { loadTheme } from '../../components/dashboard-b2b/theme'

export default {
    // Carga completa (inicial / cambio de período): oculta el dashboard con el preloader.
    loading: false,
    // Recálculo de las tablas de estadísticas en curso (botón "Actualizar"); puede tardar varios minutos.
    refreshing: false,
    params: {
        // Meses del período, siempre terminando en el mes vencido: 1 (último mes), 3 o 6.
        months: 1
    },
    // Opciones del select "Periodo".
    periodOptions: [
        { value: 1, label: 'Último mes' },
        { value: 3, label: 'Últimos 3 meses' },
        { value: 6, label: 'Últimos 6 meses' }
    ],
    // Estilo del dashboard: 'dark' (por defecto) o 'light'. Se recuerda en localStorage.
    theme: loadTheme(),
    // Opciones del select "Estilo".
    themeOptions: [
        { value: 'light', label: 'Claro' },
        { value: 'dark', label: 'Oscuro' }
    ],
    // Respuesta del endpoint: { period, kpis, charts, permissions }
    dashboard: null,
    // Mayor valor de pedidos entre los vendedores del período (carga completa, sin filtro): tope del indicador
    // de "Pedidos por Vendedor" cuando queda un solo vendedor.
    sellerMaxValue: 0,
    // Color fijo por grupo (línea) y por marca, armado en la carga sin filtro (components/dashboard-b2b/colors.js):
    // así cada elemento conserva su color al filtrar.
    colorMaps: {
        lines: {},
        brands: {}
    },
    // Recarga de las gráficas filtrables por el drill-down: no oculta el dashboard.
    filterLoading: false,
    // Filtro de drill-down activo (uno a la vez): type 'seller' | 'line' | 'brand' | 'customer' | 'product'.
    // label es el texto del badge verde, tomado de lo que se clickeó.
    filter: {
        type: null,
        id: null,
        label: null
    }
}
